import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from 'store/authStore';
import { useMenuStore } from 'store/menuStore';
import { menuService } from 'api/services/menuService';
import { AuthService } from 'api/services/authService';

export default function AuthGuard() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const updateUser = useAuthStore((s) => s.updateUser);
  const items = useMenuStore((s) => s.items);
  const setItems = useMenuStore((s) => s.setItems);

  // Si el usuario está autenticado pero el menú está vacío (page reload),
  // recargar el menú Y los permisos del servidor para evitar permisos stale.
  useEffect(() => {
    if (isAuthenticated && items.length === 0) {
      Promise.all([
        menuService.getUserMenu(),
        AuthService.check().catch(() => null),
      ]).then(([menuItems, checkData]) => {
        setItems(menuItems);
        // Emulacion: el servidor es quien lo sabe, leyendo el claim del token.
        // Se sincroniza SIEMPRE que el check responda, incluso con la bandera
        // en null, porque esta linea es la que repone la franja de aviso tras
        // recargar la pagina y la que la apaga si la sesion ya no es una
        // emulacion. Fiarse de lo que el navegador guardo dejaria al
        // superadmin editando como otro usuario sin aviso en pantalla.
        if (checkData && checkData.impersonatedBy !== undefined) {
          useAuthStore.setState({ impersonatedBy: checkData.impersonatedBy ?? null });
        }
        if (checkData?.permissions) {
          // keyProfile también: si la key del perfil cambió (db/113), el
          // usuario la toma con solo recargar, sin volver a iniciar sesión.
          updateUser({
            permissions: checkData.permissions,
            isSuperadmin: checkData.isSuperadmin,
            ...(checkData.keyProfile !== undefined ? { keyProfile: checkData.keyProfile } : {}),
            // Título (db/127): si se lo cambian, aparece con solo recargar.
            ...(checkData.title !== undefined ? { title: checkData.title } : {}),
          });
        }
      }).catch(() => {});
    }
  }, [isAuthenticated, items.length, setItems, updateUser]);

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
